export default {"src":"/_next/static/media/series_placeholder.b3374de9.svg","height":102,"width":102,"blurWidth":0,"blurHeight":0};